import { useState } from "react";
import { Loader2, LocateFixed } from "lucide-react";
import { MAPS_LINK, waLink } from "@/data/business";

export const WA_ORDER_FALLBACK_MSG = "مرحباً، أرغب في طلب بنشر متنقل في الرياض — سأشارك موقعي في المحادثة.";

export const LocationWhatsAppButton = ({
  label = "أرسل موقعك للفني",
  className = "",
  testid = "location-whatsapp-btn",
}) => {
  const [loading, setLoading] = useState(false);

  const send = () => {
    if (!navigator.geolocation) {
      window.open(waLink(WA_ORDER_FALLBACK_MSG), "_blank");
      return;
    }
    setLoading(true);
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const { latitude, longitude } = pos.coords;
        window.open(
          waLink(
            `مرحباً، أرغب في طلب بنشر متنقل في الرياض.\nموقعي الحالي: ${MAPS_LINK(latitude, longitude)}`
          ),
          "_blank"
        );
        setLoading(false);
      },
      () => {
        window.open(waLink(WA_ORDER_FALLBACK_MSG), "_blank");
        setLoading(false);
      },
      { enableHighAccuracy: true, timeout: 8000 }
    );
  };

  return (
    <button type="button" onClick={send} data-testid={testid} className={className} disabled={loading}>
      {loading ? <Loader2 size={18} className="animate-spin" /> : <LocateFixed size={18} />}
      {label}
    </button>
  );
};

export const WA_SERVICE_CHIPS = [
  "إصلاح بنشر",
  "تغيير وتركيب كفرات",
  "ترصيص إطارات",
  "فحص وتعبئة هواء",
  "برمجة حساس TPMS",
];
